import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { Text } from 'foundations-components/components/Text';
import { Data } from 'signup-constants/signupData/Data';
import { jsx as _jsx } from "react/jsx-runtime";
const workEmailLabelOverride = label => /*#__PURE__*/_jsx(Text, {
  as: "div",
  whiteSpace: "nowrap",
  children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Highlight: ({
        children
      }) => /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        children: children
      })
    },
    message: `data.${Data.Email}.${label}`
  })
});
export const useWorkEmailLabel = () => {
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variants
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variants(ExperimentParameterGroup.Variant_A);
  const updateEmailLabel = isAssignedToACQ173VariantA;
  if (updateEmailLabel) {
    return {
      labelOverride: workEmailLabelOverride('workEmailLabel_jsx')
    };
  }
  return {
    labelOverride: null
  };
};